export default "__VITE_ASSET__CsWN3bhd__"